export const HOME = { emergentLink: "emergent-link" };

export const NAV = {
  research: "nav-research",
  runs: "nav-runs",
  custom: "nav-custom",
  telegram: "nav-telegram",
  library: "nav-library",
  settings: "nav-settings",
  logo: "brand-logo",
};

export const RESEARCH = {
  promptInput: "research-prompt-input",
  submitButton: "research-submit-button",
  ideaRow: "idea-row",
  ideaCheckbox: "idea-checkbox",
  ideaWriterSelect: "idea-writer-select",
  ideaFindMoreButton: "idea-find-more-button",
  generateSelectedButton: "generate-selected-button",
  emptyState: "research-empty-state",
  loading: "research-loading",
  pastRunItem: "past-run-item",
  newRunButton: "new-run-button",
};

export const ARTICLE = {
  headline: "article-headline",
  body: "article-body",
  excerpt: "article-excerpt",
  metaDescription: "article-meta-description",
  facebookPost: "article-facebook-post",
  instagramPost: "article-instagram-post",
  photoSuggestion: "article-photo-suggestion",
  publishDraftButton: "publish-draft-button",
  publishLiveButton: "publish-live-button",
  editButton: "article-edit-button",
  saveButton: "article-save-button",
  backButton: "article-back-button",
};

export const LIBRARY = {
  articleRow: "library-article-row",
  filterChip: "library-filter-chip",
};

export const SETTINGS = {
  houseRuleField: "settings-house-rule",
  writerField: "settings-writer-field",
  writerAuthorSelect: "settings-writer-author-select",
  saveButton: "settings-save-button",
  resetButton: "settings-reset-button",
  syncWpButton: "settings-sync-wp-button",
  categoryItem: "settings-category-item",
  sourceRow: "settings-source-row",
  sourceEnableToggle: "settings-source-enable",
  sourceRemoveButton: "settings-source-remove",
  sourceNameInput: "settings-source-name-input",
  sourceTypeSelect: "settings-source-type-select",
  sourceValueInput: "settings-source-value-input",
  sourceProbeButton: "settings-source-probe-button",
  sourceAddButton: "settings-source-add-button",
};

export const CATEGORY_PICKER = {
  toggle: "article-category-toggle",
  option: "article-category-option",
  authorSelect: "article-wp-author-select",
};

export const IMAGES = {
  sourceImage: "source-image",
  generateButton: "generate-ai-image-button",
  generatedImage: "generated-image",
  useAsFeaturedToggle: "use-as-featured-toggle",
  promptInput: "image-prompt-input",
};
